import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';
const navVisibilitySchema = t.object({
  isToolbarVisible: t.boolean,
  isVerticalNavVisible: t.boolean
});
const navVisibility = defineMessage({
  type: 'nav-visibility',
  payloadSchema: navVisibilitySchema
});
const getNavVisibility = defineMessage({
  type: 'get-nav-visibility',
  reply: navVisibility
});
const navVisibilityChanged = defineMessage({
  type: 'nav-visibility-changed',
  payloadSchema: navVisibilitySchema
});
const changeNavVisibility = defineMessage({
  type: 'change-nav-visibility',
  payloadSchema: t.object({
    source: t.optional(t.string),
    // Who is requesting the change
    shouldShowToolbar: t.boolean,
    shouldShowVerticalNav: t.boolean
  }),
  reply: navVisibilityChanged
});
export const navVisibilityControls = {
  changeNavVisibility,
  navVisibilityChanged,
  getNavVisibility,
  navVisibility
};